import { noscroll } from "./noscroll"

//クラスに"onClick"がついていたら、data-elmで指定されているelementに"is-on"クラスをつける
let onclicks = document.querySelectorAll(".onClick")

onclicks.forEach((onclick) => {
    if (onclick.dataset.elm == "myself") {
        onclick.addEventListener("click", (e) => {
            if (e.target === e.currentTarget) {
                onclick.classList.toggle("is-on")
                toggleScroll(onclick)
            }
        })
    } else {
        onclick.addEventListener("click", () => {
            let elm = document.querySelector("#" + onclick.dataset.elm)
            elm.classList.toggle("is-on")
            // checkYoutube(elm)
            toggleScroll(elm)
        })
    }
})

/**
 * Elementを渡して、表示状態によってスクロール可否を切り替える
 * @param {Element} elm 
 */
function toggleScroll(elm) {
    noscroll(elm.classList.contains("is-on"))
}

//モーダルの背景が押されたらそのモーダルは閉じる
let modalbgs = document.querySelectorAll(".modalbg")
modalbgs.forEach((modalbg) => {
    modalbg.addEventListener("click", (e) => {
        if (e.target != e.currentTarget)
            return;
        modalbg.classList.toggle("is-on")
        toggleScroll(modalbg)
    })
})

// function checkYoutube(elm) {
//     if (elm.classList.contains("cnt__rowModal")) {
//         const targetWindow = elm.querySelector("iframe").contentWindow;

//         //APIのコマンドを送信する関数
//         const ag2ytControl = function (action, arg = null) {
//             targetWindow.postMessage('{"event":"command", "func":"' + action + '", "args":' + arg + '}', '*');
//             console.log("a")
//         };
//         ag2ytControl('stopVideo');
//     }
// }